<script lang="ts">
	import fastestLogo from "../../../core/assets/fastest-advanced-horizontal-logo-pro-tmave-pozadi-rgb.svg";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import imgRocksPatternFooter from "../../../core/assets/images/rocks-pattern-footer.png?webp&w=2817&imagetools";
	import { Locale, type LocalizedString } from "../../../core/schema/Locale";
	import { sameValueForEveryLocale } from "../../../core/utils/sameValueForEveryLocale";
	import Link from "./Link.svelte";
	import jamujamLogoDarkBackground from "../../../core/assets/jamujam-logo-dark-background.svg";

	import { getTenant } from "../contexts/tenantContextKey";
	import { getGlobalSettings } from "../getGlobalSettings";
	const { locale } = getTenant();
	const { WEB_URL } = getGlobalSettings();

	interface FooterMenuItem {
		id: string;
		name: LocalizedString;
		href: LocalizedString;
		target: string;
	}

	const footerMenu: FooterMenuItem[] = [
		{
			id: "about",
			name: {
				cs: "O Jamujam",
				en: "About Jamujam",
				de: "Über Jamujam",
				hu: "A Jamujamról",
				pl: "O Jamujam",
			},
			href: sameValueForEveryLocale("https://jamujamstore.com/pribeh-jamujam/"),
			target: "_self",
		},
		{
			id: "donate",
			name: {
				cs: "Chci podpořit Jamujam",
				en: "Donate to Jamujam",
				de: "Spenden für Jamujam",
				hu: "Támogatnám a Jamujamot",
				pl: "Wesprzyj Jamujam",
			},
			href: sameValueForEveryLocale("https://jamujamstore.com/"),
			target: "_self",
		},
		{
			id: "faq",
			name: {
				cs: "Často kladené otázky",
				en: "Frequently Asked Questions",
				de: "Häufig gestellte Fragen",
				hu: "Gyakran ismételt kérdések",
				pl: "Najczęściej zadawane pytania",
			},
			href: {
				cs: `${WEB_URL}/faq_cz.html`,
				en: `${WEB_URL}/faq_en.html`,
				de: `${WEB_URL}/faq_en.html`,
				hu: `${WEB_URL}/faq_en.html`,
				pl: `${WEB_URL}/faq_en.html`,
			},
			target: "_blank",
		},
		{
			id: "terms-and-conditions",
			name: {
				cs: "Podmínky používání",
				en: "Terms and Conditions",
				de: "Nutzungsbedingungen",
				hu: "Felhasználási feltételek",
				pl: "Warunki korzystania",
			},
			href: {
				cs: `${WEB_URL}/terms_and_conditions_cz.html`,
				en: `${WEB_URL}/terms_and_conditions_en.html`,
				de: `${WEB_URL}/terms_and_conditions_en.html`,
				hu: `${WEB_URL}/terms_and_conditions_en.html`,
				pl: `${WEB_URL}/terms_and_conditions_en.html`,
			},
			target: "_blank",
		},
		{
			id: "personal-data-protection",
			name: {
				cs: "Ochrana osobních údajů",
				en: "Personal Data Protection",
				de: "Datenschutz",
				hu: "Személyes adatok védelme",
				pl: "Ochrona danych osobowych",
			},
			href: {
				cs: `${WEB_URL}/personal_data_processing_cz.html`,
				en: `${WEB_URL}/personal_data_processing_en.html`,
				de: `${WEB_URL}/personal_data_processing_en.html`,
				hu: `${WEB_URL}/personal_data_processing_en.html`,
				pl: `${WEB_URL}/personal_data_processing_en.html`,
			},
			target: "_blank",
		},
	];
</script>

<footer>
	<section class="bg-[#161616] pt-16 lg:pt-32">
		<div class="container flex flex-col gap-8 pb-16 text-white lg:flex-row">
			<div class="lg:min-w-[75%]">
				<StaticPicture
					class="mx-auto w-72 lg:mx-0"
					width={400}
					height={200}
					image={jamujamLogoDarkBackground}
					alt="Jamujam logo"
				/>
			</div>

			<ul>
				{#each footerMenu as menuItem}
					<li>
						<Link
							class="text-secondary-100 w-full whitespace-nowrap py-2 text-center font-semibold transition-colors duration-300 hover:text-white sm:py-3"
							href={menuItem.href[locale]}
							target={menuItem.target}
							noUnderline
						>
							{menuItem.name[locale]}
						</Link>
					</li>
				{/each}
			</ul>
		</div>
		<div
			class="text-secondary-100 text-3xs container flex flex-col items-center gap-5 lg:h-14 lg:flex-row lg:items-center lg:justify-end"
		>
			<div class="group flex cursor-pointer items-end gap-2">
				<span
					class="group-hover:decoration-secondary mb-1 underline decoration-transparent transition-[text_decoration] duration-300"
				>
					Jamujamed at
				</span>
				<a href="https://www.fastest.cz/" target="_blank">
					<StaticPicture class="mx-auto" width={200} height={42} image={fastestLogo} alt="Fastest Solution" />
				</a>
			</div>
		</div>
	</section>
</footer>
